import SplitIOModule from 'helpers/splitio';

type Args = {
  key: string;
};

type Client = { writeData: Function };

type Context = {
  client: Client;
};

export const splitIO = new SplitIOModule();

export const resolvers = {
  createSplitioClient: (_: Object, { key }: Args, { client }: Context) => {
    const splitioClient = splitIO.createClient(key);

    splitioClient.on(splitioClient.Event.SDK_READY, () => {
      client.writeData({
        data: {
          splitioEvent: splitioClient.Event.SDK_READY,
        },
      });
    });
  },
};
